import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "@/app/common/common-components/ui/Dialog";
import { Button } from "@/app/common/common-components/ui/Button";
import { Check, ExternalLink } from "lucide-react";

interface DealTrackerNotEnabledDialogProps {
  isOpen: boolean;
  onClose: () => void;
  isAdmin?: boolean;
  onRequestAccess?: () => void;
}

const DealTrackerNotEnabledDialog = ({ isOpen, onClose, isAdmin = false, onRequestAccess }: DealTrackerNotEnabledDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="tw-max-w-2xl">
        <DialogHeader>
          <DialogTitle className="tw-text-2xl">Streamline your deal management</DialogTitle>
          <DialogDescription className="tw-space-y-4 tw-pt-4">
            <p className="tw-text-base">Deal Tracker helps you streamline your real estate deals with powerful features:</p>
            <ul className="tw-list-inside tw-space-y-2 tw-text-base">
              <li className="tw-flex tw-items-center tw-gap-2">
                <Check className="tw-size-4 tw-text-primary" />
                Custom deal pipelines for sales and rentals
              </li>
              <li className="tw-flex tw-items-center tw-gap-2">
                <Check className="tw-size-4 tw-text-primary" />
                Pre-configured task templates to never miss important steps
              </li>
              <li className="tw-flex tw-items-center tw-gap-2">
                <Check className="tw-size-4 tw-text-primary" />
                Commission tracking and automated commission slips
              </li>
              <li className="tw-flex tw-items-center tw-gap-2">
                <Check className="tw-size-4 tw-text-primary" />
                Unlimited document storage with role-based access
              </li>
              <li className="tw-flex tw-items-center tw-gap-2">
                <Check className="tw-size-4 tw-text-primary" />
                Commission pipeline overview and detailed reporting
              </li>
            </ul>
            <p className="tw-text-base tw-font-medium">
              {isAdmin
                ? "As an administrator, you can enable Deal Tracker for your office. Contact our team for pricing and activation."
                : "Please contact your office administrator to enable Deal Tracker for your account."}
            </p>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="tw-flex tw-flex-row tw-justify-between tw-gap-4 tw-pt-4">
          <Button
            variant="link"
            className="tw-flex tw-items-center tw-gap-2"
            onClick={() => window.open("https://www.entegral.net/base/features/deal-tracking/", "_blank")}
          >
            Learn more about Deal Tracker
            <ExternalLink className="tw-size-4" />
          </Button>
          {!!isAdmin && <Button onClick={onRequestAccess}>Request Access</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DealTrackerNotEnabledDialog;
